import React from "react";
import { useTranslation } from "react-i18next";

const AboutSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="hakkimizda" className="w-full px-6 bg-[#ebd7b4]">
      <div className="max-w-7xl mx-auto flex flex-col">
        {/* Başlık */}
        <div className="mb-12 text-center">
          <h2 className="text-4xl md:text-6xl font-bold opacity-20 text-black font-righteous">
            AYVALIK MARİN
          </h2>
          <h3 className="text-4xl font-semibold text-black -mt-2 font-montserrat">
            {t("aboutSection.title")}
          </h3>
        </div>

        {/* İçerik */}
        <div className="flex flex-col md:flex-row items-center md:items-start gap-12">
          <div className="w-full text-black text-lg leading-relaxed font-playfair">
            <div className="text-black mb-12">
              <div className="space-y-2 text-justify leading-relaxed text-base md:text-lg">
                <p>{t("aboutSection.p1")}</p>
                <p>{t("aboutSection.p2")}</p>
                <p>
                  {t("aboutSection.p3a")}{" "}
                  <span className="text-bold text-blue-600 font-bold">CE</span>{" "}
                  {t("aboutSection.p3b")}
                </p>
                <p>{t("aboutSection.p4")}</p>
                <p className="text-center font-semibold italic text-[#0a2f4a] mt-10">
                  {t("aboutSection.slogan")}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
